// extracted by mini-css-extract-plugin
module.exports = {"strongLink":"StrongLink_strongLink__aKu5O","strongLinkInner":"StrongLink_strongLinkInner__xOii1"};